/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const channelAccountStatusEnum = {
  active: 'active',
  disabled: 'disabled',
  revoked: 'revoked',
  removed: 'removed',
} as const;

export type ChannelAccountStatusEnumKey =
  (typeof channelAccountStatusEnum)[keyof typeof channelAccountStatusEnum];

export type ChannelAccountStatus = ChannelAccountStatusEnumKey;
